<template>
  <div class="bg-white h-screen">
    <trac-loading v-if="isLoading"></trac-loading>
    <div class="w-full flex flex-wrap">
      <!-- Login Section -->
      <div class="w-full md:w-1/2 flex flex-col">
        <div
          class="flex justify-center items-center md:justify-start pt-12 md:pl-12 md:-mb-24"
        >
          <!-- <a href="#" class="bg-black text-white font-bold text-xl p-4">Logo</a> -->
          <img
            class="rounded-full"
            src="../assets/logo.png"
            alt="Traction Logo"
          /><span class="text-2xl pl-2">TractionAdmin</span>
        </div>

        <div
          class="flex flex-col justify-center md:justify-start my-auto pt-8 md:pt-0 px-8 md:px-24 lg:px-32"
        >
          <p class="text-center text-3xl">Welcome.</p>
          <form class="flex flex-col pt-3 md:pt-8" @submit.prevent="logUserIn">
            <div class="flex flex-col pt-4">
              <label for="email" class="text-xs">Email</label>
              <input
                type="email"
                id="email"
                v-model="loginDetails.email"
                placeholder="your@email.com"
                class="shadow appearance-none text-xs border rounded w-full py-2 px-3 text-gray-700 mt-1 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>

            <div class="flex flex-col pt-4">
              <label for="password" class="text-xs">Password</label>
              <input
                type="password"
                id="password"
                v-model="loginDetails.password"
                placeholder="Password"
                class="shadow appearance-none border text-xs rounded w-full py-2 px-3 text-gray-700 mt-1 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>

            <button
              type="submit"
              class="bg-gray-800 text-white font-bold text-xs hover:bg-gray-700 p-2 mt-8"
            >
              Log In
            </button>
          </form>
          <div class="text-center pt-12 pb-12">
            <p>
              Forgot Password?
              <router-link to="reset-password" class="underline font-semibold"
                >Click here.</router-link
              >
            </p>
            <p class="text-xs">
              TractionApps admin platform for managing payments for clientele
              and other logs.
            </p>
          </div>
        </div>
      </div>

      <!-- Image Section -->
      <div class="w-1/2 shadow-2xl">
        <img
          class="object-cover w-full h-screen hidden md:block"
          src="https://source.unsplash.com/IXUM4cJynP0"
        />
      </div>
    </div>

    <!-- OTP Modal -->
    <div
      v-if="showOtpModal"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    >
      <div class="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 p-6 relative">
        <button
          type="button"
          class="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          @click="closeOtpModal"
          aria-label="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </button>

        <div class="flex flex-col items-center text-center">
          <div class="w-16 h-16 flex items-center justify-center mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 text-orange-500" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
          </div>
          <h2 class="text-xl font-bold text-gray-900 mb-3">
            Enter verification code
          </h2>
          <p class="text-sm text-gray-600 mb-6">
            Please enter the verification code sent to your email address to continue.
          </p>

          <div class="flex gap-2 justify-center mb-6">
            <input
              v-for="(digit, i) in otpInputs"
              :key="i"
              :ref="'otp' + i"
              type="text"
              inputmode="numeric"
              maxlength="1"
              v-model="otpInputs[i]"
              @input="handleOtpInput($event, i)"
              @keydown="handleOtpKeydown($event, i)"
              class="w-12 h-12 text-center text-lg font-semibold border-2 border-gray-400 bg-gray-50 rounded focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-600"
            />
          </div>

          <button
            type="button"
            :disabled="!otpComplete || isLoading"
            :class="[
              otpComplete && !isLoading ? 'bg-gray-800 hover:bg-gray-700' : 'bg-gray-400 cursor-not-allowed',
              'flex items-center justify-center gap-2'
            ]"
            class="text-white font-bold text-xs w-full py-3 rounded transition-colors"
            @click="verifyOtp"
          >
            <svg
              v-if="isLoading"
              class="animate-spin h-5 w-5 text-white flex-shrink-0"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
                fill="none"
              />
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            {{ isLoading ? 'Verifying...' : 'VERIFY' }}
          </button>

          <button
            type="button"
            :disabled="resendOtpTimer > 0"
            :class="[
              'mt-4 text-sm focus:outline-none',
              resendOtpTimer > 0
                ? 'text-gray-400 cursor-not-allowed'
                : 'text-gray-600 hover:text-gray-800 underline cursor-pointer',
            ]"
            @click="resendOtp"
          >
            {{ resendOtpTimer > 0 ? `RESEND OTP (${resendOtpTimer}s)` : 'RESEND OTP' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SAVE_LOCAL_DB_DATA } from "../browser-db-config/localStorage";
import WhitelistingMixin from '../modules/WhitelistingMixin';
export default {
  mixins: [WhitelistingMixin],
  data() {
    return {
      isLoading: false,
      showOtpModal: false,
      otpInputs: ["", "", "", "", "", ""],
      resendOtpTimer: 0,
      resendTimerInterval: null,
      loginDetails: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    otpComplete() {
      return this.otpInputs.every((d) => d.length === 1);
    },
  },
  beforeDestroy() {
    this.clearResendTimer();
  },
  methods: {
    async logUserIn() {
      this.isLoading = true;
      // OLD: await this.$store.dispatch("LOG_USER_IN", this.loginDetails);
      await this.$store.dispatch("REQUEST_OTP", {
        email: this.loginDetails.email,
        password: this.loginDetails.password,
      });
      const res = this.$store.getters["GET_OTP_REQUEST_RES"];

      if (res && res.code === "OTP000" && res.status === true) {
        this.showOtpModal = true;
        this.startResendTimer();
      } else {
        alert(res?.message || "Error: Network error occurred.");
      }
      this.isLoading = false;
    },
    async verifyOtp() {
      const otp = this.otpInputs.join("");
      if (otp.length !== 6) return;

      this.isLoading = true;
      await this.$store.dispatch("COMPLETE_OTP_LOGIN", {
        email: this.loginDetails.email,
        otp,
        password: this.loginDetails.password,
      });
      const res = this.$store.getters["GET_LOGIN_RES"];

      if (res && res.status === true) {
        this.saveData("traction-app-user-data", res.data);
        await this.fetchBusinessUserDetails();
        this.compareAccount(this.loginDetails.email || "");
        this.showOtpModal = false;
        this.$router.push({ name: "QuickAccess" });
      } else {
        alert(res?.message || "Invalid OTP. Please try again.");
      }
      this.isLoading = false;
    },
    async resendOtp() {
      this.isLoading = true;
      this.otpInputs = ["", "", "", "", "", ""];
      await this.$store.dispatch("REQUEST_OTP", {
        email: this.loginDetails.email,
        password: this.loginDetails.password,
      });
      const res = this.$store.getters["GET_OTP_REQUEST_RES"];
      if (res?.code === "OTP000" && res?.status) {
        alert("OTP has been resent to your email.");
        this.startResendTimer();
      } else {
        alert(res?.message || "Failed to resend OTP.");
      }
      this.isLoading = false;
    },
    startResendTimer() {
      this.clearResendTimer();
      this.resendOtpTimer = 60;
      this.resendTimerInterval = setInterval(() => {
        this.resendOtpTimer -= 1;
        if (this.resendOtpTimer <= 0) {
          this.clearResendTimer();
        }
      }, 1000);
    },
    clearResendTimer() {
      if (this.resendTimerInterval) {
        clearInterval(this.resendTimerInterval);
        this.resendTimerInterval = null;
      }
      this.resendOtpTimer = 0;
    },
    closeOtpModal() {
      this.showOtpModal = false;
      this.otpInputs = ["", "", "", "", "", ""];
      this.clearResendTimer();
    },
    handleOtpInput(event, index) {
      const value = event.target.value.replace(/\D/g, "").slice(0, 1);
      this.$set(this.otpInputs, index, value);
      if (value && index < 5) {
        this.$nextTick(() => {
          const next = this.$refs["otp" + (index + 1)];
          const el = Array.isArray(next) ? next[0] : next;
          if (el) el.focus();
        });
      }
    },
    handleOtpKeydown(event, index) {
      if (event.key === "Backspace" && !this.otpInputs[index] && index > 0) {
        this.$nextTick(() => {
          const prev = this.$refs["otp" + (index - 1)];
          const el = Array.isArray(prev) ? prev[0] : prev;
          if (el) el.focus();
        });
      }
    },
    async fetchBusinessUserDetails() {
      await this.$store.dispatch("FETCH_BUSINESS_USER_DETAILS");
      const res = this.$store.getters["GET_BUSINESS_USER_RES"];

      if (res.status) {
        this.saveData("traction-app-current-user-business-data", res.data);
        // this.$router.push({ name: "QuickAccess" });
        // console.log(res.res)
      }
    },
    saveData(localStorageName, dataToStore) {
      SAVE_LOCAL_DB_DATA(localStorageName, dataToStore);
    },
  },
};
</script>

<style></style>
